enum RedirectMode {
  Manual = 0,
  AutoOnce = 1,
  Auto = 2
}

export default RedirectMode;
